import Controller from "@ember/controller"
import { computed } from "@ember/object"
import { inject as service } from "@ember/service"
import type { User } from "@shared/models/user"
import type Session from "cc-frontend/services/session"

export default class AdminController extends Controller {
  @service declare session: Session

  @computed("session.user.content")
  get canViewAdminRoute(): boolean {
    return (
      (this.session.user.content as User | null)?.meta.permissions.includes(
        "can-view-admin-route"
      ) || this.session.isImpersonating
    )
  }
}
